import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from './ui/card';
import { Wallet, FileText, TrendingUp } from 'lucide-react';

const FundingSupport = () => {
  const { t } = useLanguage();

  const icons = [Wallet, FileText, TrendingUp];

  return (
    <section className="py-20 medical-section-bg" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1593824261342-fd6ee146f73d)` }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
            {t.funding.title}
          </h2>
          <p className="text-xl mb-2" style={{ color: '#2D4A8F' }}>
            {t.funding.subtitle}
          </p>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t.funding.description}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {t.funding.cards.map((card, index) => {
            const IconComponent = icons[index];
            return (
              <Card 
                key={index}
                className="card-hover border-none shadow-lg bg-white"
                style={{ animationDelay: `${index * 0.1}s`, borderRadius: '16px' }}
              >
                <CardContent className="p-8">
                  {/* Icon */}
                  <div 
                    className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
                    style={{ backgroundColor: '#E7EEF9' }}
                  >
                    <IconComponent size={32} style={{ color: '#2D4A8F' }} />
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold mb-6" style={{ color: '#2D4A8F' }}>
                    {card.title}
                  </h3>

                  {/* Items List */}
                  <ul className="space-y-3 mb-4">
                    {card.items.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-3">
                        <span className="text-[#2D4A8F] font-bold mt-1">•</span>
                        <span className="text-gray-700 leading-relaxed">{item}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Optional Note */}
                  {card.note && (
                    <div 
                      className="mt-6 p-4 rounded-lg"
                      style={{ backgroundColor: '#E7EEF9' }}
                    >
                      <p className="text-sm text-gray-700 leading-relaxed">
                        <strong style={{ color: '#2D4A8F' }}>Note:</strong> {card.note}
                      </p>
                    </div>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FundingSupport;